import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay?: number): T {
  const DEFAULT_DELAY = 0.5; // in seconds
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const secondsDelay = (delay ?? DEFAULT_DELAY) * 1000;

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), secondsDelay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
